'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

const appendSlash = (path: string) => {
  if (path.endsWith('/')) {
    return path;
  }
  return `${path}/`;
};

export default function CanonicalURL() {
  const [baseURL, setBaseURL] = useState('');
  const path = usePathname();

  useEffect(() => {
    if (typeof (window as any) !== 'undefined') {
      setBaseURL((window as any)?.location?.origin);
    }
  }, []);

  if (!baseURL) return;

  const wholePath = `${baseURL}${appendSlash(path)}`;

  return <link rel='canonical' href={wholePath} />;
}
